import API from '../../../common/http/api.fetch';
import {TYPES} from './improvement-action-type.constants';
import {IDS} from './improvement-action-id.constants';
import {success, responseMessage} from '../../../common/utils/util.notifier';
import {GRID_FETCH, GRID_FILTER} from '../../../common/grid/grid.constants';
import I18N from "../../../common/utils/util.i18n";
import truncate from "lodash/truncate";
import {getDocFileNameFromPath} from "../../../common/utils/util.path";

export const fetchImprovementActionsGrid = (filter) => {
    return dispatch => {
        let assignee_uuid =  filter.assignee_uuid;
        if(!assignee_uuid && filter.my_tasks_only === 1)
            assignee_uuid =  filter.user_uuid;

        return API.fetch({
            url: '/rco/list-tasks',
            method: 'GET',
            params: {
                ...filter,
                assignee_uuid,
                task_type: 'utimca',
                task_status: filter.task_status === 'isall' ? undefined : filter.task_status,
                scheme_code: filter.scheme_code || undefined,
                keyword:     filter.keyword     || undefined,
                identifier:     undefined,
                my_tasks_only:  undefined,
                user_uuid:      undefined,
            },
        }).then(({data}) => {
            if (data.path)
                return data;
            else
                dispatch({
                    type:   GRID_FETCH,
                    id:     IDS.rcoImprovement,
                    path: IDS.improvementActionsGrid,
                    items_count: data.items_count,
                    items: data.items.map(processTaskItem)
                })
        }, error => {
            responseMessage(error);
        })
    }
}

export const fetchImprovementActionDetails = (uta_id) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/list-tasks',
            method: 'GET',
            params: {
                uta_id,
                task_type: 'utimca'
            }
        }).then(response => {
            if(!response.data.items.length)
                return {}
            return processTaskItem(response.data.items[0]);
        })
    }
}

export const fetchImprovementActionStepDetails = (uta_id) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/list-tasks',
            method: 'GET',
            params: {
                uta_id,
                task_type: 'utimas'
            }
        }).then(response => {
            if(!response.data.items.length)
                return {}
            return processTaskItem(response.data.items[0]);
        })
    }
}

const processTaskItem = (item) => {
    return { ...item,
        id: item.uta_id,
        assigneeColumn: `${item.assignee} (${item.username})`,
        // utaTypeName: I18N.translate(`ACCREDITATION.TASKS.TYPE.${item.uta_type.toUpperCase()}`),
        status_name: I18N.translate(`ACCREDITATION.TASKS.STATUS.${item.status_code.toUpperCase()}`, item.status_name),
        // acc_code: item.acc_code.toUpperCase(),
        description: item.description && (item.description.length < 64 ? item.description : `${item.description.slice(0, 64)}...`),
        requirementsColumn: truncate(JSON.parse(item.requirements).map(i => i.name).join(', '),{ 'length': 50}),
    }
}

export const fetchImprovementStepsGrid = (filter) => {
    let assignee_uuid =  filter.assignee_uuid;
    if(!assignee_uuid && filter.my_tasks_only === 1)
        assignee_uuid =  filter.user_uuid;
    return dispatch => {
        return API.fetch({
            url: '/rco/list-tasks',
            method: 'GET',
            params: {
                ...filter,
                task_type: 'utimas',
            },
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.rcoImprovement,
                path: IDS.improvementStepsGrid,
                items_count: data.items_count,
                items: data.items.map(item => {
                    const firstRequirement = JSON.parse(item.requirements)[0];
                    return {
                        ...item,
                        id: item.uta_id,
                        requirement_id: firstRequirement?.ase_id,
                        requirement_name: firstRequirement?.name || '-',
                        evidence_name: item.evidence || '-',
                        status_name: I18N.translate(`ACCREDITATION.IMPROVEMENT.STEP_STATUS.${item.status_code.toUpperCase()}`, item.status_name),
                    }
                })
            })
        }, error => {
            responseMessage(error);
        })
    }
}

export const updateImprovementAction = (data) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/update-improvement-action`,
            method: 'POST',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        },error => {
            responseMessage(error)
        });
    };
}

export const updateImprovementActionPlan = (data) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/update-improvement-action-plan`,
            method: 'POST',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        },error => {
            responseMessage(error)
        });
    };
}

export const updateImprovementActionStep = (data) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/update-improvement-action-step`,
            method: 'POST',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        },error => {
            responseMessage(error)
        });
    };
};

export const fetchRequirementEvidenceGroups = (requirement_id, loc_uuid, scheme_code) => {
    if(!requirement_id)
        return dispatch => {};

    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-groups-grid',
            method: 'GET',
            params: {
                requirement_id,
                loc_uuid,
                scheme_code,
                // scope_subject_types: 'cla,hof,slo'
            }
        }).then(({data}) => {
            dispatch({
                id:   IDS.rcoImprovement,
                type: TYPES.FETCH_REQUIREMENT_EVIDENCE_GROUPS,
                items: data[0],
            })
        }, error => {
            responseMessage(error);
        });
    };
}


export const addImprovementAction = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/add-improvement-action',
            method: 'POST',
            data,
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_ADDED');
        },error => {
            responseMessage(error)
        });
    };
}